import React, { Component } from "react"
import YSpinner from '../../elements/Spinner/Spinner'
import { teamMembers, familyIntakeStatus } from '../../variables/ComboValues'
import { InputF, TextareaF, SelectF } from '../../elements/FormFields'
import { updateElement } from "../Tree/Utils.js"
//import { InputF, TextareaF } from "../TableList/EditableCell"
//import { CalendarDay } from '../../elements/BootstrapDayPicker/BootstrapDayPicker'
import { CalendarDay2 } from '../../elements/DayPicker/DayPicker2'
import 'react-day-picker/lib/style.css'

const  microLegend = {
    "intake_date": "ת. כניסה לאינטייק",
    "intake_status": "סטטוס",
    "intake_yahav_member": "מלווה משפחה",
    "intake_qdate": "ת. ביצוע אינטייק",
    "intake_mgr_decision": "החלטת מנהלת",
    "intake_mgr_decision_explain": "הסבר החלטת מנהלת",
    "intake_family_decision": "החלטת משפחה",
    "intake_comments": "הערות"
//  "family_startprogram": "ת. הצטרפות לתכנית",
}

export class FamilyIntakeStatus extends Component {

    constructor(props) {
      super(props)
      this.state = { products: this.props.data, isUpdating:false }
      this.onSaveTable = this.onSaveTable.bind(this)
    }
    
    handleProductTable = (evt) => {
      evt.preventDefault()
      var newp= updateElement(evt, this.state.products)
      this.setState({products:newp})
    }
    handleProductTableDate = (day, key)  => {
      var newp = Object.assign(this.state.products)
      newp[key] = day
      this.setState({products:newp})
    }

    // update data base
    async onSaveTable(evt) {
      evt.preventDefault()
      const { save2DB, subTableId, familyPostId, inUpdate, mbouser } = this.props
      this.setState({isUpdating:true})
      await save2DB(familyPostId, this.state.products, subTableId, "group", inUpdate, mbouser )
      this.setState({isUpdating:false})
    }
    render() {
      const {tableTitle, mbouser, addFamily2Program} = this.props
      
      if (this.state.isUpdating)
          return <YSpinner/>

      return (
          <ProductTable 
            onProductTableUpdate={this.handleProductTable}
            onProductTableDate={this.handleProductTableDate}
            onSaveTable={this.onSaveTable} 
            tableTitle = {tableTitle} 
            products={this.state.products} 
            mbouser = {mbouser}
            addFamily2Program = {addFamily2Program}
          />
      )
    }
  }
  
  const UpdateIcons = ({products, move2Program, onSaveTable}) => {
   
    var buttonStyle = {marginRight: '5px'}
    let mgr_decision = products['intake_mgr_decision']
    let family_decision = products['intake_family_decision']
    let status = products['intake_status']

    if (mgr_decision === 'קבלה לתכנית' &&  family_decision === 'הצטרפות לתכנית' &&  status === 'סיום אינטייק')
            return <button style={buttonStyle} type="button"  className="btn btn-success pull-left" 
                        onClick={move2Program}>הצטרפות לתוכנית</button>
    
    return <button style={buttonStyle} type="button"  className="btn btn-success pull-left" 
                        onClick={onSaveTable}>עדכון</button>
  }

  class ProductTable extends Component {
    constructor(props){
        super(props)
        this.state={
            filterText : "",
            isUpdating: false
        }
    }
    
    localUpdate = (evt) => {
      //evt.preventDefault()
      //this.setState({isUpdating:true})
      this.props.onSaveTable(evt);
      //this.setState({isUpdating:false})

    }
    move2Program = (evt) => {
        evt.preventDefault()
        const intakeInfo = this.props.products
        //console.log("move2Program - this.props", this.props)
        this.setState({isUpdating:true})

        if (intakeInfo['intake_mgr_decision'] === 'קבלה לתכנית'
            &&  intakeInfo['intake_family_decision'] === 'הצטרפות לתכנית'
            &&  intakeInfo['intake_status'] === 'סיום אינטייק'){
               //alert("האינטייק עודכן והמשפחה העברה לתוכנית בהצלחה")
            //this.props.onSaveTable() - move2program ALSO UPDATES info_status
            // check all statuses allow the move
            intakeInfo['intake_status'] = 'קבלה לתכנית'
            this.props.addFamily2Program()
        } else alert("המשפחה לא העברה לתוכנית ")
        this.setState({isUpdating:false})
    }
    handleUserInput(filterText) {
        this.setState({filterText: filterText});
    }
    productData(products){
      const product = products
      const cellData=[{
        type: "date", // text
        name: "intake_date",
        value: product.intake_date,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "select",
        options: familyIntakeStatus, // ["באינטייק","מתעכב","סיום אינטייק","קבלה לתכנית","אחר"],
        name: "intake_status",
        value: product.intake_status,
        disable: 'קבלה לתכנית',
        id: product.id,
        style: {width: "130px"},
        edit: true
      },{
        type: "select",
        options: teamMembers,
        name: "intake_yahav_member",
        value: product.intake_yahav_member,
        id: product.id,
        style: {width: "130px"},
        edit: true
      },{
        type: "date", // "text"
        name: "intake_qdate",
        value: product.intake_qdate,
        id: product.id,
        style: {width: "130px"},
        placeholder: 'dd/mm/yyyy',
        edit: true
      },{
        newsection: "סיכום",
        type: "select",
        options:["המשך בירור","דחיה","קבלה לתכנית","בהמתנה לתכנית","אחר"],
        name: "intake_mgr_decision",
        value: product.intake_mgr_decision,
        id: product.id,
        style: {width: "150px"},
        edit: true
      },{
        type: "select",
        options:["המשך בירור","ויתור","הצטרפות לתכנית","אחר"],
        name: "intake_family_decision",
        value: product.intake_family_decision,
        id: product.id,
        style: {width: "130px"},
        edit: true
      },{
        type: "textarea",
        name: "intake_mgr_decision_explain",
        value: product.intake_mgr_decision_explain,
        id: product.id,
        style: {width: "300px"},
        edit: true
      },{
        newsection: "הערות",
        type: "textarea",
        name: "intake_comments",
        value: product.intake_comments,
        id: product.id,
        style: {width: "400px"},
        edit: true
      }]
      return cellData
    }

    render() {
      // console.log("ProductTable this.state", this.state)
      if (this.state.isUpdating)
          return (<YSpinner />)

      const { onProductTableUpdate, onProductTableDate, products, tableTitle } = this.props
     
      return (
        <div className="sub-tab">
            <h2>{tableTitle}</h2>
            <UpdateIcons products={products} move2Program={this.move2Program} onSaveTable={this.localUpdate} />
            
            <div className="mynewdivform family-intake">
                <ProductRow 
                    onProductTableUpdate={onProductTableUpdate} 
                    onProductTableDate = { onProductTableDate}
                    cd={this.productData(products) /*cellData*/}
                    />
            </div>
        </div>
      )
    }
  }

class ProductRow extends React.PureComponent {
    
    render() {
      const {onProductTableUpdate, onProductTableDate, cd} = this.props
      var key = 0;
      return (
        <div className="eachRow">
          {cd.map(cellInfo => {
              if (cellInfo.newsection !== undefined)
                return(
                <React.Fragment key={key++}>
                  <h3 key={key++} >{cellInfo.newsection}</h3>
                  <EditableFormCell key={key++} onProductTableUpdate={onProductTableUpdate} onProductTableDate = { onProductTableDate} cellData={cellInfo} />
                </React.Fragment>
                )
              return (<EditableFormCell key={key++} onProductTableUpdate={onProductTableUpdate} onProductTableDate={onProductTableDate} cellData={cellInfo} /> )
          })}
        </div>
      )
    }
  }

  class EditableFormCell extends React.Component {
    constructor(props){
      super(props)
      this.state = {date: this.props.cellData.value}
      //this.handleChange = this.handleChange.bind(this) - arrow function, no need
    }
    
    //handleChange = event => {};
    handleChange = changeEvent => {
      this.setState({date: changeEvent.target.value})
      //this.props.onChange(changeEvent)
    }
    
    render() {
        const tp = this.props
        const tpc = tp.cellData

        if (tpc.type === "date"){
         return (
            <div className="form-cell-box-inline">
              <label htmlFor={tpc.id}>{microLegend[tpc.name]}</label>
              {<CalendarDay2
                  tpc = {tpc}
                  value = {tpc.value}
                  selected={new Date()}
                  onChange={this.handleChange}
                  handleChangeDate={tp.onProductTableDate} // {this.handleChangeDate}
              />}
            </div>
          )
        }
        if (tpc.type === "select"){
          return(
            <div className="form-cell-box-inline">
              <label  htmlFor={tpc.id}>{microLegend[tpc.name]}</label><br />
              <SelectF tpc={tpc} tp={tp} />
            </div>
          )
        }
        if (tpc.type === "textarea"){
          return(
            <div className="form-cell-box-inline">
              <label  htmlFor={tpc.id}>{microLegend[tpc.name]}</label><br />
              <TextareaF tpc={tpc} tp={tp} />
            </div>
          )
        }
        return (
            <div className="form-cell-box-inline">
             <label  htmlFor={tpc.id}>{microLegend[tpc.name]}</label><br />
             <InputF tpc={tpc} tp={tp} />
            </div>
        )
    }
  }
  